var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cus-dialog",
    {
      attrs: {
        title: "身份验证",
        width: _vm.width,
        visible: _vm.dialogVisible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "checkPw" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "4rem",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "账号", prop: "username" } },
                [
                  _c("span", { staticStyle: { color: "#fff9f6" } }, [
                    _vm._v(_vm._s(_vm.form.username)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "密码", prop: "pwdVal" } },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "new-password",
                      placeholder: "请输入密码验证",
                      "show-password": "",
                    },
                    nativeOn: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.submit($event)
                      },
                    },
                    model: {
                      value: _vm.form.pwdVal,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "pwdVal",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.pwdVal",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permisaction",
                      rawName: "v-permisaction",
                      value: ["btn:save"],
                      expression: "['btn:save']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.submit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }